/**
 * All product photography from /public directory.
 * Filenames kept exactly as uploaded for zero-config serving.
 * Used across all pages for consistent image references.
 */

export const CATEGORY_TILES = [
  {
    id: "classic-blue",
    title: "CLASSIC INDIGO BLUE",
    color: "Rinsin blue",
    fit: "Bootcut fit",
    image: '/rayyandenimwebsite collections photos/WhatsApp Image 2026-09-06 at 4.42.01 PM.jpeg',
    tag: "Core Essential"
  },
  {
    id: "dark-selvage",
    title: "DARK & DEEP SELVAGE",
    color: "Blue selvedge",
    fit: "Straight fit",
    image: '/rayyandenimwebsite collections photos/WhatsApp Image 2026-09-06 at 4.41.25 PM.jpeg',
    tag: "Red-Line Edge"
  },
  {
    id: "black-denim",
    title: "ONYX & CHARCOAL BLACK",
    color: "Dk black",
    fit: "Slim tapper",
    image: '/rayyandenimwebsite collections photos/WhatsApp Image 2026-09-06 at 4.41.35 PM.jpeg',
    tag: "Eco-Enzyme Wash"
  },
  {
    id: "vintage-washed",
    title: "ARTISAN WASHED DENIM",
    color: "Vintage blue",
    fit: "Straight ankle",
    image: '/rayyandenimwebsite collections photos/WhatsApp Image 2026-09-06 at 4.41.59 PM.jpeg',
    tag: "Vintage Wash"
  },
  {
    id: "jackets",
    title: "DENIM OUTERWEAR & JACKETS",
    color: "Dark indigo",
    fit: "Relaxed fit",
    image: '/rayyandenimwebsite collections photos/WhatsApp Image 2026-09-06 at 4.42.00 PM.jpeg',
    tag: "Trucker Fits"
  }
];

export const COLLECTION_VIDEOS = [
  '/rayyandenimwebsite collections photos/WhatsApp Video 2026-09-06 at 4.42.35 PM.mp4',
  '/rayyandenimwebsite collections photos/WhatsApp Video 2026-09-06 at 4.42.35 PM (1).mp4',
  '/rayyandenimwebsite collections photos/WhatsApp Video 2026-09-06 at 4.42.34 PM.mp4',
  '/rayyandenimwebsite collections photos/WhatsApp Video 2026-09-06 at 4.42.44 PM (2).mp4',
  '/rayyandenimwebsite collections photos/WhatsApp Video 2026-09-06 at 4.42.44 PM (1).mp4',
  '/rayyandenimwebsite collections photos/WhatsApp Video 2026-09-06 at 4.42.44 PM.mp4'
];

export const COLLECTION_PHOTOS = [
  '/rayyandenimwebsite collections photos/WhatsApp Image 2026-09-06 at 4.40.35 PM.jpeg',
  '/rayyandenimwebsite collections photos/WhatsApp Image 2026-09-06 at 4.41.25 PM.jpeg',
  '/rayyandenimwebsite collections photos/WhatsApp Image 2026-09-06 at 4.41.35 PM.jpeg',
  '/rayyandenimwebsite collections photos/WhatsApp Image 2026-09-06 at 4.41.59 PM.jpeg',
  '/rayyandenimwebsite collections photos/WhatsApp Image 2026-09-06 at 4.42.00 PM.jpeg',
  '/rayyandenimwebsite collections photos/WhatsApp Image 2026-09-06 at 4.42.01 PM.jpeg',
  '/rayyandenimwebsite collections photos/WhatsApp Image 2026-09-06 at 4.42.02 PM.jpeg',
  '/rayyandenimwebsite collections photos/WhatsApp Image 2026-09-06 at 4.42.03 PM.jpeg',
  '/rayyandenimwebsite collections photos/WhatsApp Image 2026-09-06 at 4.42.04 PM.jpeg',
  '/rayyandenimwebsite collections photos/WhatsApp Image 2026-09-06 at 4.42.05 PM (1).jpeg',
  '/rayyandenimwebsite collections photos/WhatsApp Image 2026-09-06 at 4.42.05 PM (2).jpeg',
  '/rayyandenimwebsite collections photos/WhatsApp Image 2026-09-06 at 4.42.05 PM.jpeg',
  '/rayyandenimwebsite collections photos/WhatsApp Image 2026-09-06 at 4.42.06 PM.jpeg',
  '/rayyandenimwebsite collections photos/WhatsApp Image 2026-09-06 at 4.42.07 PM.jpeg',
  '/rayyandenimwebsite collections photos/WhatsApp Image 2026-09-06 at 4.42.08 PM.jpeg',
  '/rayyandenimwebsite collections photos/WhatsApp Image 2026-09-06 at 4.42.09 PM.jpeg',
  '/rayyandenimwebsite collections photos/WhatsApp Image 2026-09-06 at 4.42.10 PM.jpeg',
  '/rayyandenimwebsite collections photos/WhatsApp Image 2026-09-06 at 4.42.11 PM (1).jpeg',
  '/rayyandenimwebsite collections photos/WhatsApp Image 2026-09-06 at 4.42.11 PM.jpeg',
  '/rayyandenimwebsite collections photos/WhatsApp Image 2026-09-06 at 4.42.12 PM.jpeg',
  '/rayyandenimwebsite collections photos/WhatsApp Image 2026-09-06 at 4.42.13 PM.jpeg',
  '/rayyandenimwebsite collections photos/WhatsApp Image 2026-09-06 at 4.42.14 PM.jpeg',
  '/rayyandenimwebsite collections photos/WhatsApp Image 2026-09-06 at 4.42.16 PM (1).jpeg',
  '/rayyandenimwebsite collections photos/WhatsApp Image 2026-09-06 at 4.42.16 PM.jpeg',
  '/rayyandenimwebsite collections photos/WhatsApp Image 2026-09-06 at 4.42.17 PM.jpeg',
  '/rayyandenimwebsite collections photos/WhatsApp Image 2026-09-06 at 4.42.18 PM.jpeg',
  '/rayyandenimwebsite collections photos/WhatsApp Image 2026-09-06 at 4.42.19 PM.jpeg',
  '/rayyandenimwebsite collections photos/WhatsApp Image 2026-09-06 at 4.42.20 PM.jpeg',
  '/rayyandenimwebsite collections photos/WhatsApp Image 2026-09-06 at 4.42.21 PM.jpeg',
  '/rayyandenimwebsite collections photos/WhatsApp Image 2026-09-06 at 4.42.22 PM.jpeg',
  '/rayyandenimwebsite collections photos/WhatsApp Image 2026-09-06 at 4.42.23 PM.jpeg',
  '/rayyandenimwebsite collections photos/WhatsApp Image 2026-09-06 at 4.42.24 PM.jpeg',
  '/rayyandenimwebsite collections photos/WhatsApp Image 2026-09-06 at 4.42.25 PM.jpeg',
  '/rayyandenimwebsite collections photos/WhatsApp Image 2026-09-06 at 4.42.26 PM.jpeg',
  '/rayyandenimwebsite collections photos/WhatsApp Image 2026-09-06 at 4.42.27 PM.jpeg',
  '/rayyandenimwebsite collections photos/WhatsApp Image 2026-09-06 at 4.42.28 PM.jpeg',
  '/rayyandenimwebsite collections photos/WhatsApp Image 2026-09-06 at 4.42.29 PM (1).jpeg',
  '/rayyandenimwebsite collections photos/WhatsApp Image 2026-09-06 at 4.42.29 PM.jpeg',
  '/rayyandenimwebsite collections photos/WhatsApp Image 2026-09-06 at 4.42.30 PM (1).jpeg',
  '/rayyandenimwebsite collections photos/WhatsApp Image 2026-09-06 at 4.42.30 PM (2).jpeg',
  '/rayyandenimwebsite collections photos/WhatsApp Image 2026-09-06 at 4.42.30 PM.jpeg',
  '/rayyandenimwebsite collections photos/WhatsApp Image 2026-09-06 at 4.42.31 PM (1).jpeg',
  '/rayyandenimwebsite collections photos/WhatsApp Image 2026-09-06 at 4.42.31 PM (2).jpeg',
  '/rayyandenimwebsite collections photos/WhatsApp Image 2026-09-06 at 4.42.31 PM.jpeg',
  '/rayyandenimwebsite collections photos/WhatsApp Image 2026-09-06 at 4.42.32 PM (1).jpeg',
  '/rayyandenimwebsite collections photos/WhatsApp Image 2026-09-06 at 4.42.32 PM (2).jpeg',
  '/rayyandenimwebsite collections photos/WhatsApp Image 2026-09-06 at 4.42.32 PM.jpeg',
  '/rayyandenimwebsite collections photos/WhatsApp Image 2026-09-06 at 4.42.33 PM (1).jpeg',
  '/rayyandenimwebsite collections photos/WhatsApp Image 2026-09-06 at 4.42.33 PM (2).jpeg',
  '/rayyandenimwebsite collections photos/WhatsApp Image 2026-09-06 at 4.42.33 PM (3).jpeg',
  '/rayyandenimwebsite collections photos/WhatsApp Image 2026-09-06 at 4.42.33 PM.jpeg',
  '/rayyandenimwebsite collections photos/WhatsApp Image 2026-09-06 at 4.42.34 PM (1).jpeg',
  '/rayyandenimwebsite collections photos/WhatsApp Image 2026-09-06 at 4.42.34 PM.jpeg',
  '/rayyandenimwebsite collections photos/WhatsApp Image 2026-09-06 at 4.42.35 PM.jpeg',
  '/rayyandenimwebsite collections photos/WhatsApp Image 2026-09-06 at 4.42.36 PM (1).jpeg',
  '/rayyandenimwebsite collections photos/WhatsApp Image 2026-09-06 at 4.42.36 PM (2).jpeg',
  '/rayyandenimwebsite collections photos/WhatsApp Image 2026-09-06 at 4.42.36 PM.jpeg',
  '/rayyandenimwebsite collections photos/WhatsApp Image 2026-09-06 at 4.42.37 PM (1).jpeg',
  '/rayyandenimwebsite collections photos/WhatsApp Image 2026-09-06 at 4.42.37 PM (2).jpeg',
  '/rayyandenimwebsite collections photos/WhatsApp Image 2026-09-06 at 4.42.37 PM.jpeg',
  '/rayyandenimwebsite collections photos/WhatsApp Image 2026-09-06 at 4.42.38 PM (1).jpeg',
  '/rayyandenimwebsite collections photos/WhatsApp Image 2026-09-06 at 4.42.38 PM (2).jpeg',
  '/rayyandenimwebsite collections photos/WhatsApp Image 2026-09-06 at 4.42.38 PM.jpeg',
  '/rayyandenimwebsite collections photos/WhatsApp Image 2026-09-06 at 4.42.39 PM (1).jpeg',
  '/rayyandenimwebsite collections photos/WhatsApp Image 2026-09-06 at 4.42.39 PM (2).jpeg',
  '/rayyandenimwebsite collections photos/WhatsApp Image 2026-09-06 at 4.42.39 PM (3).jpeg',
  '/rayyandenimwebsite collections photos/WhatsApp Image 2026-09-06 at 4.42.39 PM.jpeg',
  '/rayyandenimwebsite collections photos/WhatsApp Image 2026-09-06 at 4.42.40 PM (1).jpeg',
  '/rayyandenimwebsite collections photos/WhatsApp Image 2026-09-06 at 4.42.40 PM (2).jpeg',
  '/rayyandenimwebsite collections photos/WhatsApp Image 2026-09-06 at 4.42.40 PM.jpeg',
  '/rayyandenimwebsite collections photos/WhatsApp Image 2026-09-06 at 4.42.41 PM (1).jpeg',
  '/rayyandenimwebsite collections photos/WhatsApp Image 2026-09-06 at 4.42.41 PM (2).jpeg',
  '/rayyandenimwebsite collections photos/WhatsApp Image 2026-09-06 at 4.42.41 PM.jpeg',
  '/rayyandenimwebsite collections photos/WhatsApp Image 2026-09-06 at 4.42.42 PM (1).jpeg',
  '/rayyandenimwebsite collections photos/WhatsApp Image 2026-09-06 at 4.42.42 PM (2).jpeg',
  '/rayyandenimwebsite collections photos/WhatsApp Image 2026-09-06 at 4.42.42 PM.jpeg',
  '/rayyandenimwebsite collections photos/WhatsApp Image 2026-09-06 at 4.42.43 PM (1).jpeg',
  '/rayyandenimwebsite collections photos/WhatsApp Image 2026-09-06 at 4.42.43 PM (2).jpeg',
  '/rayyandenimwebsite collections photos/WhatsApp Image 2026-09-06 at 4.42.43 PM.jpeg',
  '/rayyandenimwebsite collections photos/WhatsApp Image 2026-09-06 at 4.42.44 PM.jpeg'
];

export const PRODUCT_IMAGES = COLLECTION_PHOTOS;

export const HERO_IMAGES = COLLECTION_PHOTOS.slice(0, 6);

export const FACTORY_VIDEO = COLLECTION_VIDEOS[0];

export const FACTORY_PHOTOS = COLLECTION_PHOTOS.slice(5, 11);
